// extracted by mini-css-extract-plugin
export default {"mensaje":"PNRValidateForm_mensaje__l4hPS","errorMessage":"PNRValidateForm_errorMessage__E2knD","successMessage":"PNRValidateForm_successMessage__Yd9JC"};